import React, { ProviderProps, ReactNode, useContext, useEffect, useMemo, useRef, useState } from "react";
import { STD } from "../components/cursor/cursors/STD";
import { PLZ } from "../components/cursor/cursors/PLZ";
import { HAM } from "../components/cursor/cursors/HAM";
import { YOY } from "../components/cursor/cursors/YOY";
import { KY1 } from "../components/cursor/cursors/KY1";
import { KY2 } from "../components/cursor/cursors/KY2";
import { KY3 } from "../components/cursor/cursors/KY3";
import PlayerProvider from "./PlayerProvider";
import { CRS_INFO_HAM, CRS_INFO_KY1, CRS_INFO_KY2, CRS_INFO_KY3, CRS_INFO_PLZ, CRS_INFO_YYO } from "../components/MagicCursor";

export enum CursorState {
    STD,
    HAM,
    PLZ,
    YOY,
    KY1,
    KY2,
    KY3
}

export type CursorContext = {
    state : CursorState,
    setState : React.Dispatch<React.SetStateAction<CursorState>>,
    setStateFromCode : (code: string) => void,
    plzchg : boolean,
    setPlzchg : React.Dispatch<React.SetStateAction<boolean>>
};

const context = React.createContext<CursorContext>({
    state : CursorState.STD,
    setState : (s) => {},
    setStateFromCode : () => {},
    plzchg : false,
    setPlzchg : () => {}
});

const CursorProvider = ({ children } : ProviderProps<any>) => {
    const playerProvider = useContext(PlayerProvider.context);
    const cachedStateString : string|null = localStorage.getItem('mcs');
    const cachedStateIndex : number = cachedStateString !== null ? parseInt(cachedStateString) : 0;
    const cachedState : CursorState = cachedStateIndex;
    const [state, setState] = useState(cachedState);
    const [plzchg, setPlzchg] = useState(false);
    const [crs, setCrs] = useState<ReactNode>(<STD/>);

    useEffect(() => {
        const index : number = state;
        localStorage.setItem('mcs', index.toString());

        switch (state)
        {
            case CursorState.STD:
            default:
                setCrs(<STD/>);
                break;
            case CursorState.HAM:
                setCrs(<HAM/>);
                break;
            case CursorState.PLZ:
                setCrs(<PLZ/>);
                break;
            case CursorState.YOY:
                setCrs(<YOY/>);
                break;
            case CursorState.KY1:
                setCrs(<KY1/>);
                break;
            case CursorState.KY2:
                setCrs(<KY2/>);
                break;
            case CursorState.KY3:
                setCrs(<KY3/>);
                break;
        }
    }, [state]);

    const setStateFromCode = (code : string) =>
    {
        switch(code)
        {
            case CRS_INFO_HAM.key:
                playerProvider.unlockCursor(code);
                setState(CursorState.HAM);
                break;
            case CRS_INFO_PLZ.key:
                playerProvider.unlockCursor(code);
                setState(CursorState.PLZ);
                break;
            case CRS_INFO_YYO.key:
                playerProvider.unlockCursor(code);
                setState(CursorState.YOY);
                break;
            case CRS_INFO_KY1.key:
                playerProvider.unlockCursor(code);
                setState(CursorState.KY1);
                break;
            case CRS_INFO_KY2.key:
                playerProvider.unlockCursor(code);
                setState(CursorState.KY2);
                break;
            case CRS_INFO_KY3.key:
                playerProvider.unlockCursor(code);
                setState(CursorState.KY3);
                break;
            default:
                setState(CursorState.STD);
                break;
        }
    };

    const value : CursorContext = useMemo(() => ({ state, setState, setStateFromCode, plzchg, setPlzchg }), [ state, plzchg ]);

    return (
        <context.Provider value={value}>
            {children}
            {crs}
        </context.Provider>
    );
};

CursorProvider.context = context;

export default CursorProvider;